export const stepTitles = ['اطلاعات سازمانی', 'اطلاعات مکانی'];
